import { gql } from '@apollo/client'

export const Q_AUTH_QUERY = gql`
  query {
    auth
  }
`

export const Q_MEDIA_PATH = gql`
  query {
    getMediaPath
  }
`

export const Q_MANUFACTURER = gql`
  query {
    rManufacturer {
      id
      name
      logo
      details
      code
    }
  }
`

export const Q_MFT_MODELS = gql`
  query GetMftModels($id: Int) {
    rManufacturer(id: $id) {
      id
      name
      vehiclemodelSet {
        id
        name
        image {
          image
          altText
        }
      }
    }
  }
`

export const Q_VEHICLE_MODELS = gql`
  query {
    rVehicleModel {
      id
      name
      image {
        image
        altText
      }
    }
  }
`

export const Q_COUNTRIES = gql`
  query {
    rCountries
  }
`

export const Q_ENVIRONMENT_NAMES = gql`
  query {
    getEnvironment {
      name
    }
  }
`

export const Q_ENVIRONMENT = gql`
  query {
    getEnvironment {
      name
      panoThumb
      id
      pano
    }
  }
`
export const Q_VEHICLE_TYPES = gql`
  query {
    rVehicleType {
      id
      vehicleType
      icon {
        uuid
        image
        altText
      }
    }
  }
`
export const Q_HEX_COLORS = gql`
  query {
    rHexColor {
      id
      name
      hex
    }
  }
`

export const Q_HEX_COLOR = gql`
  query GetHexColor($id: Int!) {
    rHexColor(id: $id) {
      hex
    }
  }
`

export const Q_MAKE_VARIANT = gql`
  query GetMakeVariant($id: Int) {
    rVehicleModel(id: $id) {
      image {
        image
      }
      vehiclemakeSet {
        year
        id
        vehiclevariantSet {
          id
          name
          model {
            model
            baked
            thumb {
              image
              altText
            }
          }
          colorInterior {
            hex
          }
          colorBody {
            hex
          }
        }
      }
    }
  }
`
export const Q_VARIANT_MODELS = gql`
  query GetVariantModels($id: Int) {
    rVehicleVariant(id: $id) {
      name
      make {
        id
      }
      id
      model {
        thumb {
          image
          altText
        }
      }
    }
  }
`
//materials

export const Q_MATERIAL_TYPE = gql`
  query GetMaterialType($id: Int) {
    rMaterialType(id: $id) {
      id
      name
    }
  }
`
export const Q_MATERIAL_TYPES = gql`
  query GetMaterialTypes($id: Int) {
    rMaterialType(id: $id) {
      id
      name
      roughness
      roughnessMap
      metalness
      normalMap
      normalSizeU
      normalSizeV
      normalStrength
      albedoMap
    }
  }
`
export const Q_MATERIAL_CATALOGUE = gql`
  query GetMaterialCatalogue($id: Int) {
    rMaterialCatalogue(id: $id) {
      id
      name
      logo
    }
  }
`
export const Q_MATERIAL_SWATCHES = gql`
  query GetMaterialSwatches($id: Int) {
    rMaterialCatalogue(id: $id) {
      name
      swatches {
        id
        name
        cieL
        cieA
        cieB
        cieC
        cieH
        chex
        order
        code
        codeStore
        highlight
        materialType {
          id
          name
        }
      }
    }
  }
`
export const Q_MATERIAL_CAT_SWATCH_ID = gql`
  query GetMaterialCatalogueSwatchesId($id: Int) {
    rMaterialCatalogue(id: $id) {
      swatches {
        id
      }
    }
  }
`

export const Q_MATERIAL_SWATCH = gql`
  query GetMaterialSwatches($id: Int) {
    rMaterialSwatch(id: $id) {
      swatches {
        id
        name
        roughness
        metalness
        normalMap
        albedoMap
        roughnessMap
        normalStrength
        normalSizeU
        normalSizeV
        detail
        cieL
        cieA
        cieB
        cieC
        cieH
        chex
        order
        code
        highlight
        materialCatalogue
        materialType
        preview
      }
    }
  }
`
